import { TabTemplatesListScreen } from '../../tab-templates-list-screen/TabTemplatesListScreen';
import type { TabTemplatesListScreenEntity } from '../../tab-templates-list-screen/TabTemplatesListScreen.entity';
import type { TRenderScreen, TSettingsScreenOptions } from '../SettingsScreenRendererService';

export function renderTabTemplatesListScreen(
  screen: TabTemplatesListScreenEntity,
  options: TSettingsScreenOptions,
): TRenderScreen {
  return () => <TabTemplatesListScreen stack={options.stack} screen={screen} />;
}
